<template>
  <IconLucideLayoutGrid />
</template>
